import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

/** Ends the session, drops every cached read, and goes to the login screen. */
export function useLogout() {
  const nav = useNavigate()
  const qc = useQueryClient()
  return useCallback(async () => {
    try {
      await api.logout()
    } finally {
      qc.clear()
      nav('/login')
    }
  }, [nav, qc])
}
